export enum ExclusionRuleScopeType {
  Metric = 'metric',
  Model = 'model'
}

export enum ExclusionRuleMatchType {
  All = 'AND',
  Any = 'OR'
}

export type ExclusionRuleExclusionType = 'record_identifier' | 'field_name'

export interface EligibleExclusionField {
  name: string
  type: string
  exclusion_type: ExclusionRuleExclusionType[]
  filterPredicates: string[]
}

export type ExclusionValueShape = 'one_or_more' | 'exactly_one' | 'exactly_two' | 'none'

export type ExclusionFieldType = 'string' | 'number' | 'timestamp' | 'array' | 'boolean'

export interface ExclusionFieldOperator {
  predicate: string
  label: string
  value_shape: ExclusionValueShape
}

export interface ExclusionField {
  name: string
  label: string
  type: ExclusionFieldType
  default_predicate: string
  operators: ExclusionFieldOperator[]
  /** Record-page filter operator -> exclusion operator. */
  filter_conversions: Record<string, string>
}

export interface ExclusionFieldsResponse {
  cpi_id: string
  record_identifier: string
  fields: ExclusionField[]
}

export interface ExclusionRulePredicateValue {
  values: string[]
}

export interface ExclusionRuleConditionInput {
  id?: string
  field_name: string
  predicate_type: string
  predicate_value: ExclusionRulePredicateValue
}

export interface ExclusionRuleCondition extends ExclusionRuleConditionInput {
  id: string
  rule_id: string
  deleted_at: string | null
}

export interface CreateExclusionRulePayload {
  scope_type: ExclusionRuleScopeType
  scope_id: string
  rule_name: string
  reason: string | null
  match_type?: ExclusionRuleMatchType
  conditions: ExclusionRuleConditionInput[]
}

export interface UpdateExclusionRulePayload {
  version: number
  rule_name: string
  reason: string | null
  match_type: ExclusionRuleMatchType
  conditions: ExclusionRuleConditionInput[]
}

export interface ExclusionRule {
  id: string
  tenant_slug: string
  scope_type: ExclusionRuleScopeType
  scope_id: string
  rule_name: string
  reason: string | null
  match_type: ExclusionRuleMatchType
  version: number
  created_by: string
  updated_by: string | null
  deleted_at: string | null
  created_at: string
  updated_at: string | null
  last_edited_at?: string | null
  excluded_count: number
  computed_at: string | null
  conditions: ExclusionRuleCondition[]
}

export interface ExclusionRulesListResponse {
  rules: ExclusionRule[]
  last_updated: string | null
}

export interface ExcludedRecordsPayload {
  cpi_id: string
  query_filter?: Record<string, unknown> | null
  limit?: number
  page?: number
}

export interface ExcludedRecordsResponse<T = Record<string, unknown>> {
  data: T[]
  pagination: {
    current_page: number
    next_page: number | null
    previous_page: number | null
    total_results: number
  }
  last_updated: string | null
  excluded_count: number
}

export const EXCLUDED_COUNT_NOT_CALCULATED = -1

export const MAX_CONDITION_VALUES = 1000
